function cryptoproEsignView(selector, opt) {
    this.selector = selector;
    this.root = null;
    this.elements = {};
    this.init = this.init.bind(this);
    this.hideDetailsCert = true;
    // this.hideDetailsCert = opt.hideDetailsCert || false;

    this._certInfoLabels = {
        subject: 'Владелец',
        issuer: 'Издатель',
        from: 'Выдан',
        till: 'Действителен до',
        algorithm: 'Алгоритм ключа',
        provname: 'Криптопровайдер',
        privateKeyLink: 'Ссылка на закрытый ключ',
        status: 'Статус',
        location: 'Установлен в хранилище',
    };
}

cryptoproEsignView.prototype = {
    getTemplate: function() {
        return (
            `<div>
				<div class="card mr-2">
					<div class="card-header" data-role="info-plugin">
						<div class="d-flex flex-wrap align-items-center">
							<span>Информация о плагине криптопро</span>
							<span class="ml-2 badge badge-warning" data-role="plugin-status">Загрузка плагина...</span>
							<a class="ml-auto small" data-role="setup-plugin-link" target="_blank" href="https://docs.cryptopro.ru/cades/plugin/plugin-installation-windows">Установка плагина</a>
						</div>
						<div class="small">
							<div>Версия плагина: <span data-role="plugin-version">-</span></div>
							<div>Версия криптопровайдера: <span data-role="plugin-csp-version">-</span></div>
							<div>Криптопровайдер: <span data-role="plugin-csp-name">-</span></div>
						</div>
					</div>
					<div class="card-body py-2">
						<div class="card-title d-flex flex-wrap align-items-center">
							<span>Доступные сертификаты</span>
							<a class="ml-2 small" data-role="setup-ukep-link" target="_blank" href="https://install.kontur.ru">Установка УКЭП</a>
						</div>
                        <div class="alert alert-warning small" data-role="how-install-cert">Если ваша электронная подпись не отображается в списке, попробуйте установить ее с помощью онлайн-сервисов (например <a href="https://install.kontur.ru" target="_blank">https://install.kontur.ru</a>) или обратитесь за консультацией к организации выдавшей эту электронную подпись.</div>
						<div data-role="cert-list">
							<div class="alert alert-warning" data-role="msg-cert">Нет доступных сертификатов</div>
							<select class="form-control mr-2" data-role="cert-select" required></select>
						</div>
                        <div class="mt-1" data-role="info-cert-list"></div>
					</div>
					<div class="alert" data-role="message"></div>
					<div class="text-center mt-2 small" data-role="loading">
                    </div>
				</div>
			</div>`
        );
    },
    init: function(waitDomLoad) {
        var self = this;
        return new Promise(function(resolve) {
            if (waitDomLoad) {
                document.addEventListener('DOMContentLoaded', function() {
                    self._init();
                    resolve();
                });
            } else {
                self._init();msg-cert
                resolve();
            }
        });
    },
    reset: function() {
        this.updateCertInfo({});
        this.setMessage('');
        this.elements.selectCert.val('');
        this.setLoading(false);
    },
    _init: function() {
        this.container = $(this.selector);
        if (!this.container) {
            throw new Error();
        }

        this.root = this.getRoot();
        this.elements.msgCert = this.root.find('[data-role="msg-cert"]');
        this.elements.howInstallCert = this.root.find('[data-role="how-install-cert"]');
        this.elements.selectCert = this.root.find('[data-role="cert-select"]');
        this.elements.certInfoList = this.root.find('[data-role="info-cert-list"]');
        this.elements.pluginInfo = this.root.find('[data-role="info-plugin"]');
        this.elements.message = this.root.find('[data-role="message"]');
        this.elements.setupPluginLink = this.root.find('[data-role="setup-plugin-link"]');
        this.elements.setupPluginUkep = this.root.find('[data-role="setup-ukep-link"]');
        this.elements.loading = this.root.find('[data-role="loading"]');

        this.container.append(this.root);
        // this.elements.certInfoList.hide()
        this.elements.selectCert.hide()
        this.elements.message.hide()
        this.elements.howInstallCert.hide();
    },
    getRoot: function() {
        return $(this.getTemplate());
    },

    setMessageCert(message) {
        this.elements.msgCert.html(message || 'Нет доступных сертификатов');
    },


    setMessage(message, type = 'success') {
        if (!message) {
            this.elements.message.html('');
            this.elements.message.hide();
            return;
        }
        const defaultClass = ['alert small m-0'];
        defaultClass.push(`alert-${type}`);

        if (Array.isArray(message)) {
            this.elements.message.html(message.join('</br>'));
        } else {
            this.elements.message.html(message);
        }

        this.elements.message.addClass(defaultClass).show();
    },
    setStatus() {

    },
    updatePluginInfo: function(data) {
        var pVersion = data.pluginVersion || '-';
        var cspVersion = data.cspVersion || '-';
        var cspName = data.cspName || '-';

        this.elements.pluginInfo.find('[data-role="plugin-status"]').attr('class', '').addClass('ml-2 badge badge-' + data.statusCode).text(data.statusText);
        
        switch (data.statusCode) {
            case 'danger':
                this.elements.setupPluginLink.show();
                this.elements.setupPluginUkep.show();
                break;
            case 'warning':
                this.elements.setupPluginLink.show();
                this.elements.setupPluginUkep.hide();
                break;
            default:
                this.elements.setupPluginLink.hide();
                this.elements.setupPluginUkep.hide();
        }

        if (pVersion) {
            this.elements.pluginInfo
                .find('[data-role="plugin-version"]')
                .text(pVersion);
        }
        if (cspVersion) {
            this.elements.pluginInfo
                .find('[data-role="plugin-csp-version"]')
                .text(cspVersion);
        }
        if (cspName) {
            this.elements.pluginInfo
                .find('[data-role="plugin-csp-name"]')
                .text(cspName);
        }
    },
    updateSelectCert: function(optList) {
        if (!optList.length) {
            this.elements.msgCert.show();
            this.elements.selectCert.hide();
            this.elements.howInstallCert.show();
            return;
        }

        this.elements.msgCert.hide();
        this.elements.selectCert.show();
        this.elements.howInstallCert.show();
        this.elements.selectCert.html('');

        var result = [];

        result.push(
            $('<option value="" disabled selected>Выберите сертификат</option>')
        );
        var options = optList.reduce(function(acc, el) {
            acc.push($('<option value="' + el.value + '">' + el.text + '</option>'));
            return acc;
        }, []);

        this.elements.selectCert.append(result.concat(options));
    },
    //вызывает колбэк с самим элементом селекта, потому что по нему определяется сертификат
    setHandlerSelect: function(handler) {
        this.elements.selectCert.on('change', (e) => {
            handler(e.target)
        });
    },

    getCertInfoContainerTemplate() {
        const id = `cert-info-${Math.random().toString(36).substr(2, 9)}`;

        return $(`<div class="card">
            <div class="card-header p-0" id="headingOne">
                <button 
                    type="button"
                    class="text-left btn btn-sm btn-link btn-block" 
                    data-toggle="collapse" 
                    data-target="#${id}" 
                    aria-expanded="true" 
                    aria-controls="collapseOne"
                > Детальная информация о сертификате
                </button>
            </div>

            <div id="${id}" class="collapse ${!this.hideDetailsCert ? 'show' : ''}" aria-labelledby="headingOne">
                <div class="card-body p-0"></div>
            </div>
        </div>`);
    },

    updateCertInfo: function(data) {
        // list-group list-group-flush small
        if (!Object.keys(data).length) {
            this.elements.certInfoList.html('');
            // this.elements.certInfoList.hide();
            return;
        }
        var result = Object.keys(this._certInfoLabels).map(
            function(key) {
                var label = this._certInfoLabels[key];
                var classItem = data[key].success ? '' : ' text-danger';
                var text = data[key].value || '-';

                return '<li class="list-group-item p-2' + classItem + '"><b>' + label + ': </b>' + text + '</li>';
            }.bind(this)
        );
        result = ['<ul class="list-group list-group-flush small">', ...result, '</ul>'].join('');

        const container = this.getCertInfoContainerTemplate();
        container.find('.card-body').html(result);

        this.elements.certInfoList.html(container);
    },
    createEsignCallback: function(data) {
        var text = '',
            classAlert = '';
        if (!data.success || !data.signature) {
            text = data.text || 'Ошибка создания электронной подписи';
            classAlert = 'alert-danger';
        } else {
            text = data.text || 'Подпись успешно создана';
            classAlert = 'alert-success';
        }

        modalPopup({
            title: 'Создание электронной подписи',
            content: '<p class="alert' + classAlert + '">' + text + '</p>'
        });

        // else{
        // 	var $btn = $('#SignFileBtn')
        // 		,btnText = $btn.html();
        // 	$btn.prop('disabled',true).html('Отправка данных...')
        // 	$.ajax({
        // 		type: 'POST',
        // 		url: window.esignatureUploadUrl,
        // 		data: {'esign': sign}
        // 	})
        // 	.always(function(response){
        // 		if(response && response.success){
        // 			$('.esign-interface').hide();
        // 			$('.esign-complete').show();
        // 		}
        // 		$btn.prop('disabled',false).html(btnText);
        // 		modalPopup({
        // 			title: 'Сохранение электронной подписи'
        // 			,content: (function(){
        // 					if(response){
        // 						if(response.success)
        // 							return '<p class="alert alert-success">'+response.data+'</p>'
        // 								+'<p><a href="?action=esign-download&ajax=Y" target="_blank"><i class="fas fa-download mr-1"></i>Скачать подписанные результаты голосования</a></p>'
        // 								+'<p class="small"><em>Для проверки электронной подписи и извлечения файла с результатами можно воспользоваться <a href="https://www.justsign.me/verifyqca/Verify/" target="_blank"><b>онлайн сервисом</b></a> или программой "<b>Инструменты КриптоПро</b>" на Вашем компьютере</em></p>';
        // 						if(response.errors)
        // 							return '<p class="alert alert-danger">'+response.errors+'</p>';
        // 					}
        // 					return '<p class="alert alert-danger">Возникла непредвиденная ошибка</p>';
        // 				})()
        // 		});
        // 	});
        // }
    },
    setLoading(isSet) {
        if(!isSet) {
            this.elements.loading.html('');
            return;
        }
        
        this.elements.loading.html(`
            <div class="spinner-border text-secondary" role="status">
                <span class="sr-only">Loading...</span>
            </div>`
        );
        
    },
    setValidationCertSelect(isValid) {
        if(isValid) {
            this.elements.selectCert.removeClass('is-invalid');
        } else {
            this.elements.selectCert.addClass('is-invalid');
        }
    }
};

export default cryptoproEsignView;
